import React from "react";
import { Flex } from "@jsq/ds/core";
import { CancelButton, FormTextInput, SubmitButton } from "@jsq/ds/forms";
import { Sizes } from "@jsq/ds/styles";
import { jointAccountTypeLabels } from "../../../../utils/account_types";
import { ComplianceCountrySelect } from "../../../AddressInput/ComplianceCountrySelect";
import { AccountTypeDropdown } from "../../../common/AccountTypeDropdown";
import { FieldGroup } from "../../../common/FieldGroup";
import { SimpleFormRow } from "../../../common/SimpleFormRow";

export const JointDetailsForm = ({
  onBack,
  isUpdating,
}: {
  onBack: () => void;
  isUpdating: boolean;
}) => {
  return (
    <>
      <FieldGroup title={"Details"} meta={{ headerType: "h4" }}>
        <SimpleFormRow>
          <AccountTypeDropdown
            name="accountType"
            accountTypes={jointAccountTypeLabels}
            placeholder="Select joint ownership type"
            label="Joint ownership type"
          />
        </SimpleFormRow>
        <SimpleFormRow>
          <FormTextInput
            key="legalBusinessName"
            data-testid="legalBusinessName"
            name="legalBusinessName"
            label="Legal business name"
            placeholder="Enter legal business name"
            isFullWidth
          />
        </SimpleFormRow>
        <SimpleFormRow>
          <ComplianceCountrySelect label="Domicile country" />
        </SimpleFormRow>
      </FieldGroup>
      <Flex justifyContent="flex-end" gap={Sizes.MD}>
        <CancelButton onClick={onBack}>Back</CancelButton>
        <SubmitButton isLoading={isUpdating}>Save</SubmitButton>
      </Flex>
    </>
  );
};
